export const colors = {
    // Neutral
    neutral0: "#ffffff",
    neutral2: "#f5f4f7",
    neutral3: "#dfe3e8",
    neutral4: "#cac9d8",
    neutral8: "#303336",
    // Primary
    primary0: "#d4cafe",
    primary6: "#542EFF",
    primary7: "#311B92",
    primary8: "#181357",

    // Secondary
    secondary1: "#f7f9fc",
    secondary2: "#e7e6fc",
    secondary3: "#c9c5fc",
    secondary4: "#9383f7",
    secondary5: "#6c50e6",
    secondary6: "#4628c1",
    secondary7: "#311b92",
    secondary8: "#181357",
    // Accent
    accent1: "#ffe8eb",
    accent2: "#fec0ce",
    accent3: "#ff98b7",
    accent4: "#fa76ae",
    accent5: "#eb59ae",
    accent6: "#be428e",
    accent7: "#872c6a",
    accent8: "#3d1d34",
    // Info
    info1: "#ebf4fa",
    info2: "#dceefa",
    info3: "#b4e0fa",
    info4: "#73b6fa",
    info5: "#3c90f0",
    info6: "#1867c2",
    // Success
    success1: "#e4f7e8",
    success2: "#cef0d6",
    success3: "#a2e8b3",
    success4: "#60d17b",
    success5: "#3aba58",
    success6: "#36a04f",
    success7: "#1e7e46",
    success8: "#03461f",
    // Error
    error0: "#fff4f6",
    error1: "#fbeae5",
    error2: "#fad1c8",
    error3: "#fdac9a",
    error4: "#fb826a",
    error5: "#ed4640",
    error6: "#ce2620",
    error7: "#a80f0a",
    error8: "#890400",
};

export const borders = {
    width: "1px",
    radius: "0px",
};

export const timings = {
    quick: "0.1s",
    medium: "0.4s",
};

const theme = { colors };

export default theme;
